import Vue from 'vue';

Vue.component('purchase-index', () =>
    import(/* webpackChunkName: 'purchase-index' */ './purchase-index.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/purchase/index.js